import { ActionEstadosWidgets, ActionListaResumenCerca, ElementoListaResumenCapa } from '../classes/reducerClasses';

function removeAllResaltadosListaOfListaResumen(listaResumen){
    if (Array.isArray(listaResumen.lista)){
        listaResumen.lista = listaResumen.lista.map(elementoListaResumen => ({...elementoListaResumen, resaltado: false}));
    }
}

function cambiarVisibilidadGrupoListaOfListaResumen(listaResumen, indexElementoAgrupacion, visible){
    if (Array.isArray(listaResumen.lista)){
        const { indexIni, indexFin } = listaResumen.lista[indexElementoAgrupacion];
        const auxLista =  listaResumen.lista.map((elementoListaResumen, index) => {
            if (elementoListaResumen.tipo === ElementoListaResumenCapa.tipoGraphic && index >= indexIni && index <= indexFin){
                return { ...elementoListaResumen, visible: visible }
            } else {
                return elementoListaResumen;
            }
        });
        auxLista[indexElementoAgrupacion].desplegado = visible;
        listaResumen.lista = auxLista;
    }
}

export const reducerListaResumenCerca = (state, action) => {
    //dispatchListaResumenCerca - visor.jsx
    if (action.type === ActionListaResumenCerca.tipoCambiarListaResumen){
        const nuevaListaResumen = action.payload;
        return nuevaListaResumen;
    }
    const auxState = {...state};
    if (action.type === ActionListaResumenCerca.tipoResaltarElemento){
        const indexElemento = action.payload;
        auxState.lista[indexElemento].resaltado = true;
    } else if (action.type === ActionListaResumenCerca.tipoRemoveAllResaltados){
        removeAllResaltadosListaOfListaResumen(auxState);
    } else if (action.type === ActionListaResumenCerca.tipoCambiarVisibilidadGrupo){
        cambiarVisibilidadGrupoListaOfListaResumen(auxState, action.payload.indexElementoAgrupacion, action.payload.visible);
    }
    return auxState;
}

export const reducerEstadosWidgets = (state, action) => {
    //dispatchEstadosWidgets - visor.jsx
    //El state es un objeto de clase EstadosWidgets
    let nuevoState = null;
    if (action.type === ActionEstadosWidgets.tipoCambiarValor){
        nuevoState = action.payload.valor;
    } else if (action.type === ActionEstadosWidgets.tipoInvertirValor){
        nuevoState = !state[action.payload.propEstadosWidgets];
    }
    return {...state, [action.payload.propEstadosWidgets]: nuevoState};
}